module.exports = __webpack_public_path__ + "static/media/tesevidio.16bf94e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tesevidio.mp4
// module id = tDiv
// module chunks = 1